import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import { IUsuario } from '../interfaces';

interface UserDetailsProps {
    open: boolean;
    onClose: () => void;
    user: IUsuario | null;
}

const UserDetails: React.FC<UserDetailsProps> = ({ open, onClose, user }) => {
    if (!user) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Detalhes do Usuário</DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Nome:</Typography>
                    <Typography>{user.nome}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">E-mail:</Typography>
                    <Typography>{user.email}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Telefone:</Typography>
                    <Typography>{user.telefone || 'N/A'}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Perfil:</Typography>
                    <Typography>{user.perfil}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Ativo:</Typography>
                    <Typography>{user.ativo ? 'Sim' : 'Não'}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Data de Criação:</Typography>
                    <Typography>{user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'}</Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserDetails;